import { render, staticRenderFns } from "./BulkDeposits.vue?vue&type=template&id=3eb745c4"
import script from "./BulkDeposits.vue?vue&type=script&lang=js"
export * from "./BulkDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports